// extracted by mini-css-extract-plugin
module.exports = {"container":"fixed-period_container__15Isd","timeContainer":"fixed-period_timeContainer__2aLCz","title":"fixed-period_title__2BtBw","dateText":"fixed-period_dateText__fy5gi"};